// SSO / marketplace login hand-off tokens arrive in the URL fragment
// (`#access_token=...&refresh_token=...`). Sentry runs with `sendDefaultPii`, 100%
// browser tracing, and session replay, and it initializes at app bootstrap BEFORE
// any route effect can scrub the hash — so the JWTs would otherwise be captured in
// the pageload transaction / replay URL and leak to telemetry.
//
// `stashAuthHandoffFromHash` runs at the very top of bootstrap, before Sentry.init:
// it moves the tokens out of the URL into module memory (never storage) and drops
// the fragment from the address bar, so telemetry never sees the JWTs. The hand-off
// routes (`/login/success`, `/marketplace/landing`) then read them via
// `takeAuthHandoff`.

let handoff: string | null = null

export const stashAuthHandoffFromHash = () => {
  const hash = window.location.hash.replace(/^#/, "")
  if (hash && new URLSearchParams(hash).get("access_token")) {
    handoff = hash
    // Drop the fragment from the visible URL before Sentry (or anything else) reads it.
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    )
  }
}

export const takeAuthHandoff = (): {
  accessToken: string
  refreshToken: string
} | null => {
  const raw = handoff
  handoff = null
  if (!raw) return null
  const params = new URLSearchParams(raw)
  const accessToken = params.get("access_token")
  const refreshToken = params.get("refresh_token")
  return accessToken && refreshToken ? { accessToken, refreshToken } : null
}
